module.exports = __webpack_public_path__ + "img/BackOfficeIcon.db663110.svg";